import { render, staticRenderFns } from "./SdsSection1ManufacturerForm.vue?vue&type=template&id=9bb066f6"
import script from "./SdsSection1ManufacturerForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSection1ManufacturerForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports